// extracted by mini-css-extract-plugin
export default {"container":"styles_container__r5lxt","container__user_info":"styles_container__user_info__C-7mm","container__back":"styles_container__back__Lem-Q"};